import { useEffect, useRef, useState } from "react";
import { money } from "@/lib/format";

const COLORS = { save: "var(--glow-money)", give: "var(--glow-kids)" };

// Small glass jar with coins; new coins drop in once per device when the balance grows (reduced motion: no drop).
export default function GlassJar({ kidId, jar, label, balance, testid }) {
  const key = `qhh.jar.${kidId}.${jar}`;
  const coins = Math.min(30, Math.floor(balance));
  const [drop, setDrop] = useState(0);
  const first = useRef(true);
  useEffect(() => {
    const prev = Number(localStorage.getItem(key));
    if (first.current && !Number.isNaN(prev) && localStorage.getItem(key) !== null && balance > prev) setDrop(Math.min(6, Math.max(1, Math.round(balance - prev))));
    first.current = false;
    localStorage.setItem(key, String(balance));
  }, [balance, key]);
  const rgb = COLORS[jar] || "var(--glow-kids)";
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <svg viewBox="0 0 120 150" className="h-36 w-28 sm:h-40 sm:w-32" role="img" aria-label={`${label} jar ${money(balance)}`}>
        <rect x="30" y="6" width="60" height="14" rx="5" fill={`rgba(${rgb},0.55)`} />
        <path d="M24 26 h72 q8 0 8 10 v94 q0 14 -14 14 h-60 q-14 0 -14 -14 v-94 q0 -10 8 -10z" fill="rgba(255,255,255,0.08)" stroke={`rgba(${rgb},0.7)`} strokeWidth="3" />
        {Array.from({ length: coins }, (_, i) => (
          <circle key={i} cx={34 + (i % 6) * 10.5 + ((Math.floor(i / 6) % 2) * 5)} cy={134 - Math.floor(i / 6) * 9} r="5.5" fill="#f5c542" stroke="#b88a17" strokeWidth="1" />
        ))}
        {Array.from({ length: drop }, (_, i) => (
          <circle key={`d${i}`} className="jar-drop" style={{ animationDelay: `${i * 0.18}s` }} cx={50 + (i % 3) * 10} cy="10" r="6" fill="#f5c542" stroke="#b88a17" />
        ))}
        <path d="M34 34 v80" stroke="rgba(255,255,255,0.35)" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em]" style={{ color: `rgb(${rgb})` }}>{label}</p>
      <p className="font-display text-2xl font-extrabold text-q-text" data-testid={`${testid}-balance`}>{money(balance)}</p>
    </div>
  );
}
